import {Injectable} from '@angular/core';
import {buildVersion} from '../../../version';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private readonly version: string | null = null;
  private readonly date: string | null = null;

  constructor() {
    this.version = buildVersion.buildVersion ?? 'dev';
    this.date = buildVersion.buildDate ? new Date(buildVersion.buildDate).toLocaleString() : new Date().toLocaleString();
  }

  getFullVersion(): string {
    return this.version + ' - ' + this.date;
  }
}
